import type { TranslationMessages } from '../../types';

export const point_earning: TranslationMessages = {
  title: 'Kiếm điểm',
  subtitle: 'Hoàn thành nhiệm vụ để kiếm điểm và mở khóa phần thưởng',
  how_points_work: 'Cách hoạt động của điểm',
  total_points: 'Tổng số điểm',
  points_earned_today: 'Điểm kiếm được hôm nay',
  tasks_completed: 'Nhiệm vụ đã hoàn thành',
  tasks_completed_today: 'Nhiệm vụ đã hoàn thành hôm nay',
  progress: 'Tiến độ',
  daily_completion_rate: 'Tỷ lệ hoàn thành hàng ngày',
  progress_label: 'Tiến độ',
  points_label: 'điểm',
  completed: 'Đã hoàn thành',
  complete_task: 'Hoàn thành nhiệm vụ',
  task_already_completed: 'Nhiệm vụ đã hoàn thành!',
  task_completed_message:
    'Nhiệm vụ đã hoàn thành! Bạn đã kiếm được %{points} điểm!',
  task_submitted_for_approval:
    'Nhiệm vụ đã được gửi để phê duyệt! Điểm sẽ được trao sau khi quản lý xác minh.',
  requires_approval: 'Yêu cầu phê duyệt',
  automatic: 'Tự động',
  approved: 'Đã duyệt',
  rejected: 'Đã từ chối',
  pending_approval: 'Đang chờ phê duyệt',
  pending: 'Đang chờ',
  approval_notice:
    'Nhiệm vụ này yêu cầu quản lý phê duyệt. Điểm sẽ được trao sau khi xác minh.',
  automatic_notice: 'Nhiệm vụ này tự động trao điểm khi hoàn thành.',
  types_title: 'Các loại kiếm điểm:',
  types_automatic_title: 'Điểm tự động',
  types_automatic_description:
    'Điểm được trao ngay lập tức khi bạn hoàn thành nhiệm vụ. Không cần phê duyệt - dựa trên dữ liệu hệ thống có thể xác minh.',
  types_automatic_example_1:
    'Check-in sớm (được xác minh bằng dấu thời gian hệ thống)',
  types_automatic_example_2:
    'Mục tiêu doanh số hàng ngày (được xác minh bằng dữ liệu doanh số)',
  types_automatic_example_3:
    'Điểm danh hoàn hảo (được xác minh bằng hồ sơ điểm danh)',
  types_approval_title: 'Điểm yêu cầu phê duyệt',
  types_approval_description:
    'Điểm yêu cầu quản lý xác minh trước khi được trao. Gửi hoàn thành của bạn và chờ phê duyệt.',
  types_approval_example_1:
    'Dịch vụ khách hàng xuất sắc (yêu cầu xác minh phản hồi)',
  types_approval_example_2: 'Hợp tác nhóm (yêu cầu xác minh từ đồng nghiệp)',
  types_approval_example_3:
    'Phát triển kỹ năng (yêu cầu xác minh hoàn thành đào tạo)',
  types_examples: 'Ví dụ:',
  difficulty_easy: 'Dễ',
  difficulty_medium: 'Trung bình',
  difficulty_hard: 'Khó',
  system_title: 'Hệ thống điểm Neko',
  system_description:
    'Kiếm điểm bằng cách hoàn thành nhiệm vụ hàng ngày và đạt được các mốc quan trọng. Điểm có thể được đổi để nhận phần thưởng và sự công nhận.',
  how_it_works: 'Cách hoạt động:',
  rule_complete_tasks: 'Hoàn thành nhiệm vụ để kiếm điểm',
  rule_difficulty_based: 'Điểm được trao dựa trên độ khó của nhiệm vụ',
  rule_daily_reset: 'Nhiệm vụ hàng ngày đặt lại sau mỗi 24 giờ',
  rule_bonus_challenges:
    'Thử thách hàng tuần và hàng tháng cung cấp điểm thưởng',
  rule_redeem: 'Điểm có thể được đổi trong Cửa hàng điểm',
  benefits_title: 'Lợi ích:',
  benefit_redeem: 'Đổi điểm để nhận phần thưởng',
  benefit_badges: 'Mở khóa huy hiệu thành tích',
  benefit_leaderboard: 'Leo lên bảng xếp hạng',
  benefit_recognition: 'Kiếm được sự công nhận từ quản lý',
  benefit_perks: 'Truy cập các đặc quyền và lợi ích độc quyền',
  got_it: 'Đã hiểu!',
  how_to_complete: 'Cách hoàn thành:',
  close: 'Đóng',
  points: 'điểm',
};
